import { Route, Routes } from 'react-router-dom';
import AddTestWizardRoute from './AddTestWizardRoute';
import CloudTestAgentConfigPreview from './CloudTestAgentConfigPreview';
import CodeTestAgentConfigPreview from './CodeTestAgentConfigPreview';
import CustomSqlTestAgentConfigPreview from './CustomSqlTestAgentConfigPreview';
import EditTestWizardRoute from './EditTestWizardRoute';
import PlanEditTestWizardRoute from './PlanEditTestWizardRoute';
import TestManagementPage from './TestManagementPage';

const TestManagementRouter = () => (
  <Routes>
    <Route
      path="cloud-agent-preview"
      element={<CloudTestAgentConfigPreview />}
    />
    <Route path="code-agent-preview" element={<CodeTestAgentConfigPreview />} />
    <Route
      path="custom-sql-agent-preview"
      element={<CustomSqlTestAgentConfigPreview />}
    />
    <Route path="add-test/:mode" element={<AddTestWizardRoute />} />
    <Route path="edit-test" element={<EditTestWizardRoute />} />
    <Route path="plan-edit-test" element={<PlanEditTestWizardRoute />} />
    <Route path="*" element={<TestManagementPage />} />
  </Routes>
);

export default TestManagementRouter;
